export const AUTH_QR_PATH = '/v3/auth/QR'
export const AUTH_QR_PATH_PREFIX = `${AUTH_QR_PATH}/`
